module.exports = __webpack_public_path__ + "img/steam.6e59138f.png";